import React from "react";
import { Link } from "react-router-dom";
import {
  Building2,
  Trees,
  IdCard,
  Landmark,
  Calculator,
  ScrollText,
  Receipt,
  ArrowLeftRight,
  ArrowRight,
} from "lucide-react";

const COLUMNS = [
  {
    label: "Incorporation",
    items: [
      {
        icon: Building2,
        title: "Mainland Setup",
        desc: "Trade anywhere in the UAE.",
        to: "/company-formation/mainland",
      },
      {
        icon: Trees,
        title: "Freezone Setup",
        desc: "0% corporate tax · 100% ownership.",
        to: "/company-formation/freezone",
      },
    ],
  },
  {
    label: "Visa & Banking",
    items: [
      {
        icon: IdCard,
        title: "Visa Services",
        desc: "Investor, Golden, family residency.",
        to: "/visa",
      },
      {
        icon: Landmark,
        title: "Corporate Banking",
        desc: "Tier-1 UAE bank introductions.",
        to: "/banking",
      },
    ],
  },
  {
    label: "Accounting",
    items: [
      {
        icon: Calculator,
        title: "Accounting & Bookkeeping",
        desc: "Audit-grade financials, monthly close.",
        to: "/services/accounting",
      },
      {
        icon: Receipt,
        title: "VAT",
        desc: "Registration, returns, FTA compliance.",
        to: "/services/vat",
      },
    ],
  },
  {
    label: "Tax Advisory",
    items: [
      {
        icon: ScrollText,
        title: "Corporate Tax",
        desc: "9% UAE CT registration & filings.",
        to: "/services/corporate-tax",
      },
      {
        icon: ArrowLeftRight,
        title: "Transfer Pricing",
        desc: "OECD-aligned TP documentation.",
        to: "/services/transfer-pricing",
      },
    ],
  },
];

export default function MegaMenu({ onNavigate, onMouseEnter, onMouseLeave }) {
  return (
    <div
      data-testid="v2-mega-menu"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className="fixed left-1/2 -translate-x-1/2 top-20 mt-2 w-[min(96vw,1100px)] z-50 rounded-sm bg-white border border-slate-200 shadow-2xl overflow-hidden"
    >
      <div className="grid grid-cols-1 md:grid-cols-4">
        {COLUMNS.map((col, ci) => (
          <div
            key={col.label}
            className={`p-6 ${ci > 0 ? "md:border-l border-slate-100" : ""}`}
          >
            <p className="overline text-[#3366FF] mb-4">{col.label}</p>
            <div className="space-y-1">
              {col.items.map((item) => {
                const Icon = item.icon;
                return (
                  <Link
                    key={item.title}
                    to={item.to}
                    onClick={onNavigate}
                    data-testid={`mega-${item.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    className="flex items-start gap-3 p-3 -mx-3 rounded-sm hover:bg-[#EEF2FF] transition-colors group"
                  >
                    <div className="shrink-0 w-9 h-9 rounded-sm border border-slate-200 group-hover:border-[#3366FF]/40 group-hover:bg-white inline-flex items-center justify-center text-[#3366FF]">
                      <Icon className="w-4 h-4" strokeWidth={1.75} />
                    </div>
                    <div className="min-w-0">
                      <div className="font-heading font-semibold text-[#0F172A] text-sm leading-tight group-hover:text-[#002366]">
                        {item.title}
                      </div>
                      <div className="text-xs text-slate-500 mt-0.5 leading-snug">
                        {item.desc}
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        ))}
      </div>
      <div className="bg-[#F8FAFC] border-t border-slate-200 px-6 py-4 flex items-center justify-between gap-4">
        <p className="text-sm text-slate-600">
          Not sure which service you need?{" "}
          <span className="font-heading font-semibold text-[#002366]">
            Talk to a senior advisor
          </span>{" "}
          — free, 20 minutes.
        </p>
        <Link
          to="/contact"
          onClick={onNavigate}
          className="inline-flex items-center gap-1.5 text-sm font-heading font-semibold text-[#3366FF] hover:text-[#002366] whitespace-nowrap"
        >
          Get in touch <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
